export default __webpack_public_path__ + "chatbot.accec96.png";